import {H2, styled} from "@reside/ui";

export const AdminPageTitle = styled(H2)`
  margin: 0;
  @media (min-width: ${({theme}) => theme.breakpoint.sm}px) {
    margin: 0;
  }
`;
